import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MyMapBoxMap from "../components/MyMapBoxMap";
import locationsSelector from "../selectors/locationsSelector";
import { updateLocationState } from "../actions/map";

class MapContainer extends Component {
  render() {
    const { locations, currentLocation, fleetIds } = this.props;
    return (
      <MyMapBoxMap
        fleetIds={fleetIds}
        currentLocation={currentLocation}
        locations={locations}
        updateLocationState={this.props.updateLocationState}
      />
    );
  }
}

MapContainer.propTypes = {
  fleetIds: PropTypes.array.isRequired,
  currentLocation: PropTypes.object,
  locations: PropTypes.array.isRequired,
  updateLocationState: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const locations = locationsSelector(state);
  return {
    currentLocation: state.mapReducer.currentLocation,
    fleetIds: state.filterReducer.fleetIds,
    locations,
  };
}

export default connect(mapStateToProps, { updateLocationState })(MapContainer);
